import PageHero from "@/components/feature/PageHero";
import CtaSection from "@/components/feature/CtaSection";
import Reveal from "@/components/base/Reveal";
import { features } from "@/mocks/public";

export default function FeaturesPage() {
  return (
    <div className="flex flex-col">
      <PageHero
        eyebrow="Fonctionnalités"
        current="Fonctionnalités"
        title="Une plateforme complète pour votre gestion locative"
        description="Chaque module couvre une étape de votre activité, de l'enregistrement d'un immeuble jusqu'à l'analyse de vos revenus en FCFA."
      />

      <section className="py-14 md:py-20 bg-background-50">
        <div className="container-page">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
            {features.map((feature, index) => (
              <Reveal key={feature.title} delay={index * 70} className="h-full">
                <article className="card-lift group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6 hover:border-primary-300">
                  <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-700 transition-colors duration-300 group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className={`${feature.icon} text-2xl`} aria-hidden="true" />
                  </span>
                  <h2 className="mt-4 text-lg font-heading font-semibold text-foreground-950">{feature.title}</h2>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{feature.description}</p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaSection
        title="Prêt à utiliser tous ces modules ?"
        description="Créez votre espace et activez les fonctionnalités au fur et à mesure de votre besoin."
      />
    </div>
  );
}